import React from "react";

import { usePlaylist } from "../../media-widget/hooks/usePlaylistContext";
import { useIsMobile } from "../../utils/useMediaQuery";
import CartWidgetContainer from "../product/CartWidgetContainer";
import MediaDescription from "./MediaDescription";
import PlaylistContent from "./PlaylistContent";

interface PlaylistWidgetProps {
  onOpenWebsite?: (url: string) => void;
  isPlaylist?: boolean;
}

const PlaylistWidget: React.FC<PlaylistWidgetProps> = ({
  isPlaylist = true,
}) => {
  const { mediaItems, currentMediaIndex, cartItems } = usePlaylist();
  const isMobile = useIsMobile();
  return (
    <>
      <div className="relative flex h-full max-w-full items-center justify-center text-left">
        <PlaylistContent isPlaylist={isPlaylist} />
        {cartItems.items && cartItems.items.length > 0 && (
          <div
            className="relative flex h-full flex-col bg-white"
            style={{
              width: "450px",
            }}
          >
            {!isMobile && (
              <div className="border-b border-border">
                {mediaItems[currentMediaIndex] && (
                  <MediaDescription media={mediaItems[currentMediaIndex]} />
                )}
              </div>
            )}
            <CartWidgetContainer alwaysOpen={!isMobile} hideWidget={isMobile} />
          </div>
        )}
      </div>
    </>
  );
};

export default PlaylistWidget;
